import { useDraggable } from '@dnd-kit/core';
import React, { JSX } from 'react';

interface DraggableProps {
  children: React.ReactNode;
  id: string;
}

export function Draggable(props: DraggableProps): JSX.Element {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: props.id,
  });
  const style = {
    transform: transform
      ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
      : undefined,
  };

  return (
    <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
      {props.children}
    </div>
  );
}
